"use client";

import { useEffect } from "react";

import { useAuth } from "@clerk/nextjs";

import { updateAuthStateCookie } from "@/backend/actions/auth";

export function AuthCookieSync() {
  const { isSignedIn, isLoaded } = useAuth();

  useEffect(() => {
    if (isLoaded) {
      updateAuthStateCookie(!!isSignedIn);
    }
  }, [isSignedIn, isLoaded]);

  return null;
}
